import React from "react";

interface IBookingParticipantTabletLayoutProps {
  header: React.ReactNode;
  customerType: React.ReactNode;
  meta: React.ReactNode;
  status: React.ReactNode;
  bookingSource?: React.ReactNode;
}

export function BookingParticipantTabletLayout({
  header,
  customerType,
  meta,
  status,
  bookingSource,
}: IBookingParticipantTabletLayoutProps) {
  return (
    <div className="tee-time-slot-booking-participant tee-time-slot-booking-participant--tablet">
      <div className="booking-participant_tablet-header">{header}</div>
      <div className="booking-participant_tablet-type">
        <div className="booking-participant_tablet-type-label">{customerType}</div>
        {bookingSource ? (
          <div className="booking-participant_tablet-type-source">{bookingSource}</div>
        ) : null}
      </div>
      <div className="booking-participant_tablet-footer">
        <div className="booking-participant_tablet-meta">{meta}</div>
        <div className="booking-participant_tablet-status">{status}</div>
      </div>
    </div>
  );
}
